import { Injectable } from '@angular/core';
import { BOOLEAN_OPERATOR, COMPARISON_OPERATOR, CustomTreeElement, DriveTreeElement } from '@common';
import { DriveOdataItem } from '@common/models';
import { ODataPagedResult } from '@common/odata';
import { DriveTreeOdataService } from '@common/services';
import { createTreeFromDrives, updateTotalChildren } from '@common/utils';
import { TreeElement } from 'mbs-ui-kit';
import { Observable } from 'rxjs';
import { finalize, map, take } from 'rxjs/operators';

@Injectable()
export class DriveTreeHelperService {
  constructor(private treeService: DriveTreeOdataService) {}

  requestHandlerTree(
    treeElem: DriveTreeElement,
    update: boolean,
    setLoadingFn: (val: boolean) => void
  ): (source: Observable<ODataPagedResult<DriveOdataItem>>) => Observable<DriveTreeElement[]> {
    return (source: Observable<ODataPagedResult<DriveOdataItem>>): Observable<DriveTreeElement[]> => {
      return source.pipe(
        take(1),
        map(({ data, count }) => {
          return {
            node: createTreeFromDrives(data),
            count
          };
        }),
        updateTotalChildren<DriveTreeElement>(treeElem, update),
        finalize(() => setLoadingFn(false))
      );
    };
  }

  getOdataIdFilter(path: string): string {
    const neTypeStr = `Type ${COMPARISON_OPERATOR.eq} false`;

    return path ? `Id ${COMPARISON_OPERATOR.eq} ${path} ${BOOLEAN_OPERATOR.and} ${neTypeStr}` : neTypeStr;
  }

  getRoot(item: TreeElement): TreeElement {
    let temp = item;

    while (temp.parent) {
      temp = temp.parent;
    }

    return temp;
  }

  findChildByPath(root: CustomTreeElement<any>, path: string): CustomTreeElement<any> {
    return root.children?.find((treeEl) => treeEl.id == path);
  }

  getTreeElemLoadedPage(treeElem: TreeElement): number {
    const pageSize = this.treeService.pageSize;
    const loadedCount = treeElem.children?.length || 0;
    const totalChildren = treeElem.totalChildren ?? 0;

    if (!pageSize || !totalChildren || !loadedCount || pageSize > totalChildren) return 1;

    return Math.floor(loadedCount / pageSize) + 1;
  }
}
